import { createSlice } from "@reduxjs/toolkit";

export const topEmployeesIdeasSlice = createSlice({
    name: 'topEmployeesIdeas',
    initialState: {
        id: ""
    },
    reducers:{
        setEmployeeId(state, action) {
            state.id = action.payload
        },
    }
})


export const topEmployeesIdeasAction = topEmployeesIdeasSlice.actions